
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d0739f40\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/www/newcode/platform-admin/src/style/theme.scss\",\"/data/www/newcode/platform-admin/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./forget.vue")
require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d0739f40\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/www/newcode/platform-admin/src/style/theme.scss\",\"/data/www/newcode/platform-admin/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./forget.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./forget.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d0739f40\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./forget.vue"),
  /* scopeId */
  "data-v-d0739f40",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/forget.vue
// module id = 961
// module chunks = 30